import customAxios from "../serverCall";

const createPromoCode = async (body) => {
  const response = await customAxios.post(`/admin/promo-codes/create`, body);
  return response;
};

const listPromoCodes = async (body) => {
  const response = await customAxios.post(`/admin/promo-codes/list`, body);
  return response;
};

const deletePromoCode = async (body) => {
  const response = await customAxios.post(`/admin/promo-codes/delete`, body);
  return response;
};

const updatePromoCode = async (body) => {
  const response = await customAxios.post(`/admin/promo-codes/update`, body);
  return response;
};

const PromotionService = {
  createPromoCode,
  listPromoCodes,
  deletePromoCode,
  updatePromoCode,
};

export default PromotionService;

